import React from "react";
import { Clock } from "lucide-react";

export default function ScheduleTimeline({ items, completions, disabled, onToggle }) {
  return (
    <div data-testid="timed-schedule-container" className="space-y-3">
      <p className="text-[#A3A3A3] text-sm mb-1">
        The nightly close runs 8:30 PM – 10:55 PM. Tap a block once its tasks are done.
      </p>
      <div className="relative pl-6">
        <div className="absolute left-[9px] top-2 bottom-2 w-px bg-[#2E2E2E]" />
        {items.map((it) => {
          const meta = completions[it.key];
          const done = !!meta?.checked;
          return (
            <div key={it.key} className="relative mb-3">
              <span className={`absolute -left-6 top-4 h-4 w-4 rounded-full border-2 ${done ? "bg-[#16A34A] border-[#16A34A]" : "bg-[#0E0E0E] border-[#E11D2A]"}`} />
              <button
                data-testid="checklist-item-checkbox"
                disabled={disabled}
                onClick={() => onToggle(it.key, !done)}
                className={`w-full text-left rounded-xl border p-4 transition-all disabled:cursor-not-allowed
                  ${done ? "bg-[#16A34A]/10 border-[#16A34A]/40" : "bg-[#171717] border-[#2E2E2E] hover:border-[#E11D2A]/50"}`}
              >
                <div className="flex items-center gap-2">
                  <Clock className="h-3.5 w-3.5 text-[#E11D2A]" />
                  <span className="font-mono text-xs font-semibold text-[#E11D2A]">{it.time}</span>
                  <span className="font-heading font-semibold text-[#F5F5F5]">{it.title}</span>
                </div>
                <p className={`mt-1.5 text-sm ${done ? "text-[#6B6B6B]" : "text-[#A3A3A3]"}`}>{it.detail}</p>
                {done && meta && (
                  <span className="mt-1.5 inline-block font-mono text-[11px] text-[#16A34A]">
                    Done · {meta.checked_by}
                  </span>
                )}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
